import { useState } from "react";

export default function FaqSection() {
  const [activeIndex, setActiveIndex] = useState(-1);

  const handleClick = (index: number) => {
    setActiveIndex(index === activeIndex ? -1 : index);
  };

  return (
    <div className="bg-doctio-lightgreen py-20 md:mt-32 mb-10 md:mb-32">
      <div className="mx-auto md:mb-56 container">
        <h3 className="text-doctio-green mb-8 md:mb-40 text-center text-[2.7rem] md:text-7xl font-bold">
          Oftest stillede spørgsmål
        </h3>

        <div
          onClick={() => handleClick(0)}
          className={`px-8 md:px-12 faq-item cursor-pointer relative text-left ${
            activeIndex === 0 &&
            "bg-white border rounded-xl faq-item-open border-gray-300 text-doctio-dark"
          } group md:mb-10 hover:bg-white hover:rounded-xl hover:text-doctio-dark`}
        >
          <div className="flex justify-between py-8 md:py-10">
            <div className="flex flex-col">
              <div>
                <h2
                  className={`${
                    activeIndex === 0 ? "text-doctio-dark" : "text-doctio-green"
                  }  w-[90%] md:w-full md:text-dxl mb-4 font-bold group-hover:text-doctio-dark`}
                >
                  Hvad sker der med mine data, hvis jeg beslutter at annullere
                  mit abonnoment?
                </h2>
              </div>
              <div
                className={`${
                  0 === activeIndex ? "collapsed" : ""
                } collapsible-faq text-doctio-dark m-0`}
              >
                <p>
                  Når du annullerer dit abonnoment, slettes dine data permanent,
                  dog er vi jf. regnskabslovgivningen pålagt at opbevare udvalgt
                  data i op til 5 år før de slettes permanent.
                </p>
                <div className="mt-5">
                  <p>
                    Vi prioriterer din datafortrolighed, og du kan have tillid
                    til, at dine oplysninger opbevares forsvarligt. Hvis du har
                    yderligere spørgsmål om dette, er vores supportteam klar til
                    at hjælpe.
                  </p>
                </div>
              </div>
            </div>

            <button
              className="focus:outline-none md:w-48 ml-auto absolute md:static right-6 top-14"
              onClick={() => handleClick(0)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className={`rotate-icon fill-green-800 ml-[30px] w-10 md:w-15 group-hover:fill-[#415779] ml-auto ${
                  0 === activeIndex ? "rotate-active" : ""
                } shrink-0`}
                width={30}
                height="21.036"
                viewBox="0 0 36.791 21.036"
              >
                <path
                  id="Up-icon_blue_"
                  data-name="Up-icon (blue)"
                  d="M24.59,25.941,38.5,12.019a2.618,2.618,0,0,1,3.713,0,2.651,2.651,0,0,1,0,3.724L26.452,31.517a2.624,2.624,0,0,1-3.626.077L6.954,15.754a2.63,2.63,0,0,1,3.713-3.724Z"
                  transform="translate(42.979 32.283) rotate(180)"
                />
              </svg>
            </button>
          </div>
        </div>
        <div
          onClick={() => handleClick(1)}
          className={`px-8 md:px-12 faq-item cursor-pointer relative text-left ${
            activeIndex === 1 &&
            "bg-white border rounded-xl faq-item-open border-gray-300 text-doctio-dark"
          } group md:mb-10 hover:bg-white hover:rounded-xl hover:text-doctio-dark`}
        >
          <div className="flex justify-between py-8 md:py-10">
            <div className="flex flex-col">
              <h2
                className={`${
                  activeIndex === 1 ? "text-doctio-dark" : "text-doctio-green"
                }  w-[90%] md:w-full md:text-dxl mb-4 font-bold group-hover:text-doctio-dark`}
              >
                Er der rabattter til større grupper eller instititutioner?
              </h2>
              <p
                className={`${
                  1 === activeIndex ? "collapsed" : ""
                } collapsible-faq text-doctio-dark m-0`}
              >
                Ja, det er muligt. Vi tilbyder skræddersyede løsninger til
                virksomheder, institutioner eller grupper, der ønsker at drage
                fordel af vores tjenester. Kontakt os blot og så finder vi den
                bedste løsning til jeres specfikke behov.
              </p>
            </div>

            <button
              className="focus:outline-none md:w-48 ml-auto absolute md:static right-6 top-14"
              onClick={() => handleClick(1)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className={`rotate-icon fill-green-800 ml-[30px] w-10 md:w-15 group-hover:fill-[#415779] ml-auto ${
                  1 === activeIndex ? "rotate-active" : ""
                } shrink-0`}
                width={30}
                height="21.036"
                viewBox="0 0 36.791 21.036"
              >
                <path
                  id="Up-icon_blue_"
                  data-name="Up-icon (blue)"
                  d="M24.59,25.941,38.5,12.019a2.618,2.618,0,0,1,3.713,0,2.651,2.651,0,0,1,0,3.724L26.452,31.517a2.624,2.624,0,0,1-3.626.077L6.954,15.754a2.63,2.63,0,0,1,3.713-3.724Z"
                  transform="translate(42.979 32.283) rotate(180)"
                />
              </svg>
            </button>
          </div>
        </div>
        <div
          onClick={() => handleClick(2)}
          className={`px-8 md:px-12 faq-item cursor-pointer relative text-left ${
            activeIndex === 2 &&
            "bg-white border rounded-xl faq-item-open border-gray-300 text-doctio-dark"
          } group md:mb-10 hover:bg-white hover:rounded-xl hover:text-doctio-dark`}
        >
          <div className="flex justify-between py-8 md:py-10">
            <div className="flex flex-col">
              <h2
                className={`${
                  activeIndex === 2 ? "text-doctio-dark" : "text-doctio-green"
                }  w-[90%] md:w-full md:text-dxl mb-4 font-bold group-hover:text-doctio-dark`}
              >
                Hvordan fungerer det med patientinformation og GDPR?
              </h2>
              <p
                className={`${
                  2 === activeIndex ? "collapsed" : ""
                } collapsible-faq text-doctio-dark m-0`}
              >
                Beskyttelse af patientinformation og overholdelsen af GDPR er en
                prioritet for Doctio og er en streng nødvendighed i det
                sundhedsfaglige arbejde. Vi behanlder derfor ikke eller gemmer
                ikke personfølsomme oplysninger om patienter i vores system. AL
                kommunikation med Doctios systemer sker via en krypteret
                forbindelse, herunder transmission af dine oplysninger, som
                f.eks emailadresse. Ved eventuelle yderligere spørgsmål eller
                bekymringer angående GDPR eller generel datasikkerhed er vores
                supportteam altid klar til at yde rådgivning.
              </p>
            </div>

            <button
              className="focus:outline-none md:w-48 ml-auto absolute md:static right-6 top-14"
              onClick={() => handleClick(2)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className={`rotate-icon fill-green-800 ml-[30px] w-10 md:w-15 group-hover:fill-[#415779] ml-auto ${
                  2 === activeIndex ? "rotate-active" : ""
                } shrink-0`}
                width={30}
                height="21.036"
                viewBox="0 0 36.791 21.036"
              >
                <path
                  id="Up-icon_blue_"
                  data-name="Up-icon (blue)"
                  d="M24.59,25.941,38.5,12.019a2.618,2.618,0,0,1,3.713,0,2.651,2.651,0,0,1,0,3.724L26.452,31.517a2.624,2.624,0,0,1-3.626.077L6.954,15.754a2.63,2.63,0,0,1,3.713-3.724Z"
                  transform="translate(42.979 32.283) rotate(180)"
                />
              </svg>
            </button>
          </div>
        </div>
        <div
          onClick={() => handleClick(3)}
          className={`px-8 md:px-12 faq-item cursor-pointer relative text-left ${
            activeIndex === 3 &&
            "bg-white border rounded-xl faq-item-open border-gray-300 text-doctio-dark"
          } group md:mb-10 hover:bg-white hover:rounded-xl hover:text-doctio-dark`}
        >
          <div className="flex justify-between py-8 md:py-10">
            <div className="flex flex-col">
              <h2
                className={`${
                  activeIndex === 3 ? "text-doctio-dark" : "text-doctio-green"
                }  w-[90%] md:w-full md:text-dxl mb-4 font-bold group-hover:text-doctio-dark`}
              >
                Hvordan fungerer integrationen med andre journalsystemer?
              </h2>
              <p
                className={`${
                  3 === activeIndex ? "collapsed" : ""
                } collapsible-faq text-doctio-dark m-0`}
              >
                Du kan problemfrit kopiere notater, fraser og tekststykker, du
                genererer fra Doctios WebApp, ind i forskellige journalsystemer
                som XMO, Clinea, EPJ, Sundhedsplatformen, CGM, WinPLC, og flere.
                Den nuværende kompatibilitet gør det muligt at arbejde effektivt
                med både Doctio og dit eksisterende journalsystem. Dette vil
                muliggøre endnu hurtigere journalisering.
              </p>
            </div>

            <button
              className="focus:outline-none md:w-48 ml-auto absolute md:static right-6 top-14"
              onClick={() => handleClick(3)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className={`rotate-icon fill-green-800 ml-[30px] w-10 md:w-15 group-hover:fill-[#415779] ml-auto ${
                  3 === activeIndex ? "rotate-active" : ""
                } shrink-0`}
                width={30}
                height="21.036"
                viewBox="0 0 36.791 21.036"
              >
                <path
                  id="Up-icon_blue_"
                  data-name="Up-icon (blue)"
                  d="M24.59,25.941,38.5,12.019a2.618,2.618,0,0,1,3.713,0,2.651,2.651,0,0,1,0,3.724L26.452,31.517a2.624,2.624,0,0,1-3.626.077L6.954,15.754a2.63,2.63,0,0,1,3.713-3.724Z"
                  transform="translate(42.979 32.283) rotate(180)"
                />
              </svg>
            </button>
          </div>
        </div>
        <div
          onClick={() => handleClick(4)}
          className={`px-8 md:px-12 faq-item cursor-pointer relative text-left ${
            activeIndex === 4 &&
            "bg-white border rounded-xl faq-item-open border-gray-300 text-doctio-dark"
          } group md:mb-10 hover:bg-white hover:rounded-xl hover:text-doctio-dark`}
        >
          <div className="flex justify-between py-8 md:py-10">
            <div className="flex flex-col">
              <h2
                className={`${
                  activeIndex === 4 ? "text-doctio-dark" : "text-doctio-green"
                }  w-[90%] md:w-full md:text-dxl mb-4 font-bold group-hover:text-doctio-dark`}
              >
                Hvad sker der, hvis jeg oplever tekniske problemer eller har
                brug for support?
              </h2>
              <p
                className={`${
                  4 === activeIndex ? "collapsed" : ""
                } collapsible-faq text-doctio-dark m-0`}
              >
                Du kan kontakte os via e-mail på kontakt@doctio.dk. Vi er her
                for at hjælpe, og vores supporttteam er klar til at besvare dine
                spørgsmål og løse eventuelle tekniske problemer hurtigt.
              </p>
            </div>

            <button
              className="focus:outline-none md:w-48 ml-auto absolute md:static right-6 top-14"
              onClick={() => handleClick(4)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className={`rotate-icon fill-green-800 ml-[30px] w-10 md:w-15 group-hover:fill-[#415779] ml-auto ${
                  4 === activeIndex ? "rotate-active" : ""
                } shrink-0`}
                width={30}
                height="21.036"
                viewBox="0 0 36.791 21.036"
              >
                <path
                  id="Up-icon_blue_"
                  data-name="Up-icon (blue)"
                  d="M24.59,25.941,38.5,12.019a2.618,2.618,0,0,1,3.713,0,2.651,2.651,0,0,1,0,3.724L26.452,31.517a2.624,2.624,0,0,1-3.626.077L6.954,15.754a2.63,2.63,0,0,1,3.713-3.724Z"
                  transform="translate(42.979 32.283) rotate(180)"
                />
              </svg>
            </button>
          </div>
        </div>
        <div
          onClick={() => handleClick(5)}
          className={`px-8 md:px-12 faq-item cursor-pointer relative text-left ${
            activeIndex === 5 &&
            "bg-white border rounded-xl faq-item-open border-gray-300 text-doctio-dark"
          } group md:mb-10 hover:bg-white hover:rounded-xl hover:text-doctio-dark`}
        >
          <div className="flex justify-between py-8 md:py-10">
            <div className="flex flex-col">
              <h2
                className={`${
                  activeIndex === 5 ? "text-doctio-dark" : "text-doctio-green"
                }  w-[90%] md:w-full md:text-dxl mb-4 font-bold group-hover:text-doctio-dark`}
              >
                Kan jeg få en demonstration eller træning i, hvordan platformen
                fungerer?
              </h2>

              <p
                className={`${
                  5 === activeIndex ? "collapsed" : " mt-"
                } collapsible-faq text-doctio-dark m-0`}
              >
                Absolut! Vi tilbyder en nem men omfattende tutorial side, hvor
                du kan få trin-for-trin vejledning til at udnytte alle de
                fantastiske funktioner, vi har. <br></br>
                Du kan desuden prøve Doctio Basic gratis i ubegrænset tid, eller
                du kan prøve Doctio Pro gratis i en begrænset periode. Dette
                giver dig mulighed for at udforske og prøve Doctio's program til
                fulde.
              </p>
            </div>
            <button
              className="focus:outline-none md:w-48 ml-auto absolute md:static right-6 top-14"
              onClick={() => handleClick(5)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className={`rotate-icon fill-green-800 ml-[30px] w-10 md:w-15 group-hover:fill-[#415779] ml-auto ${
                  5 === activeIndex ? "rotate-active" : ""
                } shrink-0`}
                width={30}
                height="21.036"
                viewBox="0 0 36.791 21.036"
              >
                <path
                  id="Up-icon_blue_"
                  data-name="Up-icon (blue)"
                  d="M24.59,25.941,38.5,12.019a2.618,2.618,0,0,1,3.713,0,2.651,2.651,0,0,1,0,3.724L26.452,31.517a2.624,2.624,0,0,1-3.626.077L6.954,15.754a2.63,2.63,0,0,1,3.713-3.724Z"
                  transform="translate(42.979 32.283) rotate(180)"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
